// extracted by mini-css-extract-plugin
module.exports = {"menuNavItem":"styles_menuNavItem__3LZ3E","icon":"styles_icon__25j0C","label":"styles_label__1Oz2J"};